import React from "react";
import {
  AiFillGithub,
  AiFillLinkedin,
  AiFillYoutube,
  AiOutlineArrowUp,
} from "react-icons/ai";

const Footer = () => {
  return (
    <footer>
      <div>
        <h2>Deepak Kumar</h2>
        <p>Give me a chance I will work hard and perform much better than you thought</p>
      </div>

      <aside>
        <h2>Social Media</h2>

        <article>
          <a href="https://www.youtube.com/channel/UCz7TOPS1waITD2Bfhy_LaFQ" target={"blank"}>
            <AiFillYoutube />
          </a>
          <a href="https://www.linkedin.com/in/deepak-kumar97" target={"blank"}>
            <AiFillLinkedin />
          </a>
          <a href="https://github.com/dkp5897" target={"blank"}>
            <AiFillGithub />
          </a>
        </article>
      </aside>
      <a href="#home">
        <AiOutlineArrowUp />
      </a>
    </footer>
  );
};

export default Footer;